import { Button, Col, Form, Row, Space } from "antd";
import { observer } from "mobx-react-lite";

import ErrorsFormatter from "@/ui/_common_/errors-formatter";
import { FormInput, FormItem, FormSelect } from "@/ui/_common_/form-helpers";
import { FormSpinner } from "@/ui/_common_/form-spinner";

import { NewWebsiteDomainFormState } from "./form.state";

type Props = {
  state: NewWebsiteDomainFormState;
};

export const NewWebsiteDomainFormView = observer<Props>(({ state }) => {
  const {
    intl,
    imagePacksQuery,
    templatesQuery,
    handleSubmit,
    form,
    mutation,
  } = state;

  if (
    imagePacksQuery.isIdle ||
    imagePacksQuery.isPending ||
    templatesQuery.isIdle ||
    templatesQuery.isPending
  ) {
    return <FormSpinner />;
  }

  if (imagePacksQuery.isRejected || templatesQuery.isRejected) {
    return <ErrorsFormatter queries={[imagePacksQuery, templatesQuery]} />;
  }

  const imagePacks = imagePacksQuery.data.data;
  const templates = templatesQuery.data.data;

  return (
    <Space direction="vertical">
      <ErrorsFormatter queries={[mutation]} />
      <Form
        labelCol={{ span: 8 }}
        labelAlign="left"
        wrapperCol={{ span: 16 }}
        layout="horizontal"
        onFinish={handleSubmit}
      >
        <FormItem
          form={form}
          path="domain"
          label={intl.formatMessage({ defaultMessage: "Domain" })}
        >
          <FormInput
            form={form}
            path="domain"
            placeholder={intl.formatMessage({ defaultMessage: "Enter domain" })}
          />
        </FormItem>
        <FormItem
          form={form}
          path="title"
          label={intl.formatMessage({ defaultMessage: "Title" })}
        >
          <FormInput
            form={form}
            path="title"
            placeholder={intl.formatMessage({ defaultMessage: "Enter title" })}
          />
        </FormItem>
        <FormItem
          form={form}
          path="imgPackId"
          label={intl.formatMessage({ defaultMessage: "Image pack" })}
        >
          <FormSelect
            form={form}
            path="imgPackId"
            placeholder={intl.formatMessage({
              defaultMessage: "Select image pack",
            })}
            options={imagePacks.map((pack) => ({
              value: pack.id,
              label: pack.name,
            }))}
          />
        </FormItem>
        <FormItem
          form={form}
          path="templateId"
          label={intl.formatMessage({ defaultMessage: "Template" })}
        >
          <FormSelect
            form={form}
            path="templateId"
            placeholder={intl.formatMessage({
              defaultMessage: "Select template",
            })}
            options={templates.map((template) => ({
              value: template.id,
              label: template.name,
            }))}
          />
        </FormItem>
        <Row justify="end" gutter={12}>
          <Col>
            <Button
              type="primary"
              htmlType="submit"
              loading={mutation.isPending}
            >
              {intl.formatMessage({ defaultMessage: "Create" })}
            </Button>
          </Col>
        </Row>
      </Form>
    </Space>
  );
});
